// extracted by mini-css-extract-plugin
export default {"ETA":"EUMKH","icon":"VkF7S","bigNumber":"qW4_8","rest":"qPTIk","length":"xKDox","time":"wAqqe","waves":"yxzpn"};